// Roadmap 4.1 (A2-284) — a channel the client's last filed period had
// (marketplace sales, purchase invoices ...) but this upload lacks. A
// forgotten file silently understates a return; trading may also have
// genuinely stopped, so this only asks.
import React, { useEffect, useState } from "react";
import { channelContinuity } from "../lib/api";
import { useTranslation } from "react-i18next";

export const ChannelContinuityNote = ({ calcId }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  useEffect(() => {
    let off = false;
    if (calcId) channelContinuity(calcId).then((d) => { if (!off) setData(d); }).catch(() => {});
    return () => { off = true; };
  }, [calcId]);
  if (!data || !data.compared_with || !(data.missing || []).length) return null;
  const p = data.compared_with;
  return (
    <div data-testid="channel-continuity" className="mb-4 rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-950/30 p-3 text-xs text-amber-900 dark:text-amber-100">
      <div className="font-semibold">{t("ui.channel_continuity.missing", { start: p.period_start, end: p.period_end, defaultValue: `Missing compared with your last filed period (${p.period_start} → ${p.period_end})` })}</div>
      <div className="mt-1">
        {t("ui.channel_continuity.body", { list: data.missing.map((m) => m.label).join(", "), defaultValue: `That period had ${data.missing.map((m) => m.label).join(", ")}; this upload has none. If a file was not uploaded, add it and re-run. If that trading stopped, carry on.` })}
      </div>
    </div>
  );
};
